import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.1501 5.84961L5.8501 12.1496M12.1501 12.1496L5.8501 5.84961L12.1501 12.1496Z", stroke: "#919191", strokeWidth: 0.84375, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
